import { render, staticRenderFns } from "./PointsForm.vue?vue&type=template&id=edc12c82&scoped=true&"
import script from "./PointsForm.vue?vue&type=script&lang=js&"
export * from "./PointsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc12c82",
  null
  
)

export default component.exports